/*
 * @Author: liuxw@codoon.com 
 * @Date: 2020-10-29 19:19:24 
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-10-29 19:22:52
 * @Content: day.js
 */

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from 'dayjs/plugin/duration';

dayjs.extend(customParseFormat)
dayjs.extend(duration)

const day = dayjs;

export default day;
